module.exports = __webpack_public_path__ + "img/closeOverImgTwo.142b9dd8.png";